import React, { Component } from 'react';
import TextField from 'material-ui/TextField';

class FormTextField extends Component {
    handleChange = (event, value) => {
        const { name, onChange, numberOnly } = this.props;

        onChange(name, value, numberOnly);
    };

    render() {
        const { onChange, required, numberOnly, ...props } = this.props;

        return <TextField onChange={this.handleChange} {...props} />;
    }
}

export default FormTextField;



// WEBPACK FOOTER //
// ./src/UI/FormTextField.js